import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, PlayCircle, Wallet } from "lucide-react";
import { setPaymentRequiredHandler } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/** تظهر عند أي محاولة توليد بلا رصيد (402): توضّح أن الاشتراك عبر أيقونة الشراء أو «الباقات والأرصدة»، مع رابط فيديوهات أدلة الاستخدام */
export const NoCreditDialog = () => {
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  useEffect(() => { setPaymentRequiredHandler((d) => setMsg(typeof d === "string" && d ? d : "لا يوجد رصيد كافٍ لهذه الخدمة.")); return () => setPaymentRequiredHandler(null); }, []);
  const go = (to) => { setMsg(""); navigate(to); };
  return (
    <Dialog open={!!msg} onOpenChange={(o) => !o && setMsg("")}>
      <DialogContent className="bg-popover border-border max-w-md" dir="rtl" data-testid="no-credit-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Wallet className="w-5 h-5 text-accent" /> تحتاج رصيدًا لبدء التوليد</DialogTitle>
          <DialogDescription className="text-start leading-relaxed">{msg}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Button className="w-full h-11 gap-2 font-bold" onClick={() => go("/app/packages")} data-testid="no-credit-packages-btn"><ShoppingBag className="w-4 h-4" /> الاشتراك أو شراء خدمات — الباقات والأرصدة</Button>
          <Button variant="outline" className="w-full h-11 gap-2 border-border" onClick={() => { setMsg(""); window.open("/guide#videos", "_blank"); }} data-testid="no-credit-guide-btn"><PlayCircle className="w-4 h-4" /> شاهد فيديوهات أدلة الاستخدام</Button>
        </div>
        <p className="text-[11px] text-muted-foreground text-center">يمكنك أيضًا الشراء في أي وقت من أيقونة الشراء بالأعلى. التصفح والمكتبة وجميع المسارات مفتوحة بلا رصيد.</p>
      </DialogContent>
    </Dialog>
  );
};
